import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef } from "react";
const DEFAULT_MIN_PX = 40;
const DEFAULT_MAX_PX = 160;
export type UseAutoResizeTextareaOptions = {
  minPx?: number;
  maxPx?: number;
};

/**
 * Keeps a textarea height in sync with content between min and max pixel bounds.
 */
export function useAutoResizeTextarea(value, t0) {
  const $ = _c(15);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  const ref = useRef(null);
  const minPx = options.minPx ?? DEFAULT_MIN_PX;
  const maxPx = options.maxPx ?? DEFAULT_MAX_PX;
  let t2;
  if ($[2] !== maxPx || $[3] !== minPx) {
    t2 = () => {
      const element = ref.current;
      if (!element) {
        return;
      }
      element.style.height = "0px";
      const contentHeight = element.scrollHeight;
      const nextHeight = Math.min(Math.max(contentHeight, minPx), maxPx);
      element.style.height = `${nextHeight}px`;
      element.style.overflowY = contentHeight > maxPx ? "auto" : "hidden";
    };
    $[2] = maxPx;
    $[3] = minPx;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const resize = t2;
  let t3;
  if ($[5] !== resize) {
    t3 = () => {
      resize();
    };
    $[5] = resize;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== resize || $[8] !== value) {
    t4 = [value, resize];
    $[7] = resize;
    $[8] = value;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  if ($[10] !== resize) {
    t5 = () => {
      requestAnimationFrame(() => {
        resize();
        const element_0 = ref.current;
        if (element_0) {
          element_0.scrollTop = 0;
        }
      });
    };
    $[10] = resize;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const onPaste = t5;
  let t6;
  if ($[12] !== onPaste || $[13] !== resize) {
    t6 = {
      ref,
      onPaste,
      resize
    };
    $[12] = onPaste;
    $[13] = resize;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}